export const disabledLiteProfileIsoCodes: string[] = [
  "CN",
  "HK",
  "JP",
  "KY",
  "AE",
  "MK",
];
